// extracted by mini-css-extract-plugin
export default {"container":"i5MBxwrUP8aUiKjVB1wA","avatar":"cVYAsIBDKLuWhf6XYz_a","info":"skwpdUCHL7NMJZd3wFOw","name":"nS8qSGiGgVIz7a_tvq9X","email":"tUDnbrxkqELr9UBi6Jk9"};